import AppDispatcher from '../../dispatcher/AppDispatcher';
import AccountConstants from '../../constants/AccountConstants';
import AccountParser from '../../parsers/AccountParser';
import AccountsApiUtils from '../../utils/AccountsApiUtils';

class AccountsActionCreator {
  // View Actions
  /**
   * Action to get all accounts from API
   */
  getAccountsList() {
    AppDispatcher.handleViewAction({
      actionType: AccountConstants.REQUEST_ACCOUNTS_LIST,
    });
  }

  /**
   * Action to get accounts with Ids from API
   */
  getAccountDetails(accountId) {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_ACCOUNT_DETAILS,
      data: accountId,
    });
  }

  /**
   * Action to get Terms and condition for the user if the accounts service fails
   */

  getTermsAndConditions() {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_TERMS_AND_CONDITIONS,
    });
  }

  setAccountID(id) {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.SET_ACCOUNT,
      id,
    });
  }

  /**
   * Action to handle an API call success
   * @param  {object} response getCases api response
   */
  handleAccountsListSuccess(response) {
    const accountParser = new AccountParser();
    const accountList = accountParser.parseAccountListResponse(response);
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_ACCOUNTS_LIST_SUCCESS,
      data: accountList,
    });
  }

  /**
   * Action to handle an API accounts deatils success
   */
  handleAccountsDetailsSuccess(response) {
    const accountParser = new AccountParser();
    const accountDetails = accountParser.parseAccountDetailResponse(response);
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_ACCOUNT_DETAILS_SUCCESS,
      data: accountDetails,
    });
  }

  /**
   * Action to handle error in API call of account details
   */

  handleAccountsDetailsError(id, error, status) {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_ACCOUNT_DETAILS_ERROR,
      data: error,
      errCode: status,
      id,
    });
  }

  /**
   * Action to success of Accept Terms and Conditions
   */
  handleAcceptTcSuccess() {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_ACCEPT_TC_SUCCESS,
    });
  }

  /**
   * Action to error of Accounts list get action
   */

  handleAccountsListError(error, status) {
    const accountParser = new AccountParser();
    let accountListError = '';
    if (error) {
      accountListError = accountParser.parseListErrorHandler(error);
    }
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_ACCOUNTS_LIST_ERROR,
      // error: error,
      error: accountListError,
      status,
    });
  }

  handleDangerPeriodDataSuccess(response, accid, status) {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_DANGER_PERIOD_SUCCESS,
      data: response,
      id: accid,
      status,
    });
  }

  /**
   * Action to handle success in the pots details
   */
  handlePotDataSuccess(response, accid) {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_REJIG_POT_DETAILS_SUCCESS,
      data: response,
      id: accid,
    });
  }

  resetRejigIconSavingsPots(response, accid) {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_RESET_REJIG_ICON,
      data: response,
      id: accid,
    });
  }

  /**
   * Action to reset of error flag in the stores
   */
  resetErrorFlag() {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.REQUEST_ACCOUNTS_RESET_ERROR,
    });
  }

  sortAccountList() {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.RESORT_ACCOUNT,
    });
  }

  handleAccountOrderChangesError(error) {
    AppDispatcher.handleServerAction({
      actionType: AccountConstants.ACCOUNT_REORDER_ERROR,
      data: error,
    });
  }

  /**
   * Update store once reorder is success as well as account rename is success
   */
  updateAccountsStore(response) {
    AppDispatcher.handleViewAction({
      actionType: AccountConstants.UPDATE_ACCOUNT_ORDER_AND_NICKNAME,
      data: response,
    });
  }

  requestBalance() {
    const balance_data = {
      file_type: 'csv',
    };
    AccountsApiUtils.requestBalance(balance_data);
  }
}

export default new AccountsActionCreator();
